<template>
  <v-autocomplete
    color="primary"
    v-model="materialsSelected"
    :clearable="!unclearable"
    :items="materialsItems"
    :loading="materialsLoading"
    :search-input.sync="materialsSearch"
    item-value="material_id"
    item-text="Description"
    item-disabled="disabled"
    :label="noLabel ? '' : $t('Material.title')"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
  >
  </v-autocomplete>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import StockSupplierMaterials from "@/api/supplier_materials";

export default {
  name: "StockSupplierMaterials",

  props: {
    stockId: Number,
    supplierId: Number,
    value: Object,
    noLabel: Boolean,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
  },
  computed: {
    materialsItems() {
      return this.materials.map((material) => {
        let code = (material.supply_code == "" || material.supply_code == null) ? material.material.material_code : material.supply_code;
        const Description = this.dense
          ? material.material_name
            : i18n.t(
              this.settings
                ? this.settings.material_name_display_type == 4
                  ? "Material.nameWithCodeAndStandard"
                  : this.settings.material_name_display_type == 3
                  ? "Material.materialNameWithCodeAndStandard"
                    : this.settings.material_name_display_type == 2
                    ? "Material.materialNameWithCode"
                  : "Material.materialName"
                : "Material.materialName",
                [
                  code,
                  material.material.material_name,
                  material.standard.name ? (material.standard.name.length > 12 ? material.standard.name.slice(0, 12) + "......" : material.standard.name) : "",
                ]
            );
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.material_id == material.material_id
            )
          : false;
        return Object.assign({}, material, { Description, disabled });
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  data: () => ({
    materials: [],
    materialsLoading: false,
    materialsSearch: "",
    materialsSelected: null,
  }),

  methods: {
    getMaterialsFromAPI() {
      if (this.stockId && this.supplierId) {
        this.materialsLoading = true;
        let postData = {
          stock_id: this.stockId,
          supplier_id: this.supplierId,
          readonly: 0,
        };
        let fieldFilter = [
          "SupplierMaterialRelations.id",
          "SupplierMaterialRelations.enabled",
          "SupplierMaterialRelations.supply_price",
          "SupplierMaterialRelations.material_id",
          "SupplierMaterialRelations.supplier_id",
          "SupplierMaterialRelations.supply_code",
          "StockMaterial.stock_id",
          "StockMaterial.STATUS",
          "MaterialCategory.id",
          "MaterialCategory.sort",
          "MaterialCategory.number",
          "Material.id",
          "Material.material_code",
          "Material.material_name",
          "Material.material_sname",
          "Material.pinyin",
          "Material.pinyin",
          "Material.category_code",
          "Material.sort",
          "Standard.barcode",
          "Standard.name",
        ];
        postData = Object.assign(
            {
              fieldFilter: fieldFilter,
              // 仅筛选少许必要字段
            },
            postData
        );
        StockSupplierMaterials.fetchAll(postData)
          .then(
            function (response) {
              if (response.data.status.isOK()) {
                this.materials = response.data.materials;
              }
              this.materialsLoading = false;
            }.bind(this)
          )
          .catch(
            function () {
              this.materialsLoading = false;
            }.bind(this)
          );
      }
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.materialsSelected = this.value;
      },
    },
    materialsSelected: {
      handler() {
        if (this.materialsSelected && this.materialsSelected.id)
          this.$emit("input", this.materialsSelected);
      },
    },
    stockId: {
      immediate: true, //初始赋值也调用
      handler() {
        if (typeof this.stockId != "undefined" && this.stockId != null)
          this.getMaterialsFromAPI();
      },
    },
    supplierId: {
      immediate: true,
      handler() {
        if (typeof this.supplierId != "undefined" && this.supplierId != null)
          this.getMaterialsFromAPI();
      },
    },
  },
};
</script>
